const LEGACY_MAIN_SENTENCE_PASS_COUNT = 3;
const LEGACY_SHORT_VIDEO_FALLBACK_SECONDS = 60;
const LEGACY_SHORT_VIDEO_MAIN_REPEAT_END_GRACE_SECONDS = 0.35;
const LEGACY_SHORT_VIDEO_MILLISECONDS_THRESHOLD = 1000;

const legacyShortVideoColors = Object.freeze({
  black: "#000000",
  controlDefault: "#90A4AE",
  heartActive: "#E2264D",
  heartDefault: "#AAB8C2",
  primary: "#F2CF0D",
  primaryDarker: "#F8B430",
  red: "#CF2E34",
  secondary: "#482611",
  secondaryDarker: "#391D0C",
  white: "#FFFFFF",
});

const legacyShortVideoIcons = Object.freeze({
  bookmark: Object.freeze({
    path: "M15.9 0H.6C.3 0 0 .3 0 .6v21.8c0 .2.1.4.3.5.2.1.4.1.6 0l7.3-4.5 7.3 4.5c.1.1.2.1.3.1.1 0 .2 0 .3-.1.2-.1.3-.3.3-.5V.6c.1-.3-.2-.6-.5-.6zm-.7 21.3l-6.7-4.1c-.2-.1-.4-.1-.6 0l-6.7 4.1V1.2h14v20.1zm-6.3-8.4c0 .3-.3.6-.6.6-.2 0-.3-.1-.4-.2s-.2-.3-.2-.4v-3h-3c-.5 0-.7-.3-.7-.7 0-.3.3-.6.6-.6h3v-3c0-.4.3-.6.6-.6s.6.3.6.6v3h3c.3 0 .6.3.6.6s-.3.6-.6.6h-3l.1 3.1z",
    viewBox: "0 0 16.5 23",
  }),
  loop: Object.freeze({
    path: "M512 256c0 88.225-71.775 160-160 160H110.628l68.201 68.201c4.686 4.686 4.686 12.284 0 16.971l-5.656 5.656c-4.686 4.686-12.284 4.686-16.971 0l-98.343-98.343c-4.686-4.686-4.686-12.284 0-16.971l98.343-98.343c4.686-4.686 12.284-4.686 16.971 0l5.656 5.656c4.686 4.686 4.686 12.284 0 16.971L110.628 384H352c70.579 0 128-57.421 128-128 0-28.555-9.403-54.952-25.271-76.268-3.567-4.792-3.118-11.462 1.106-15.686l5.705-5.705c5.16-5.16 13.678-4.547 18.083 1.271C499.935 186.438 512 219.835 512 256zM57.271 332.268C41.403 310.952 32 284.555 32 256c0-70.579 57.421-128 128-128h241.372l-68.201 68.201c-4.686 4.686-4.686 12.284 0 16.971l5.656 5.656c4.686 4.686 12.284 4.686 16.971 0l98.343-98.343c4.686-4.686 4.686-12.284 0-16.971L355.799 5.172c-4.686-4.686-12.284-4.686-16.971 0l-5.656 5.656c-4.686 4.686-4.686 12.284 0 16.971L401.372 96H160C71.775 96 0 167.775 0 256c0 36.165 12.065 69.562 32.376 96.387 4.405 5.818 12.923 6.432 18.083 1.271l5.705-5.705c4.225-4.224 4.674-10.893 1.107-15.685z",
    viewBox: "0 0 512 512",
  }),
  heart: Object.freeze({
    bursts: Object.freeze([
      Object.freeze({
        circles: Object.freeze([
          Object.freeze({ cx: "2", cy: "6", fill: "#9CD8C3", r: "2" }),
          Object.freeze({ cx: "5", cy: "2", fill: "#8CE8C3", r: "2" }),
        ]),
        id: "grp7",
        transform: "translate(7 6)",
      }),
      Object.freeze({
        circles: Object.freeze([
          Object.freeze({ cx: "2", cy: "7", fill: "#CC8EF5", r: "2" }),
          Object.freeze({ cx: "3", cy: "2", fill: "#91D2FA", r: "2" }),
        ]),
        id: "grp6",
        transform: "translate(0 28)",
      }),
      Object.freeze({
        circles: Object.freeze([
          Object.freeze({ cx: "2", cy: "7", fill: "#9CD8C3", r: "2" }),
          Object.freeze({ cx: "4", cy: "2", fill: "#8CE8C3", r: "2" }),
        ]),
        id: "grp3",
        transform: "translate(52 28)",
      }),
      Object.freeze({
        circles: Object.freeze([
          Object.freeze({ cx: "5", cy: "6", fill: "#CC8EF5", r: "2" }),
          Object.freeze({ cx: "2", cy: "2", fill: "#CC8EF5", r: "2" }),
        ]),
        id: "grp2",
        transform: "translate(44 6)",
      }),
      Object.freeze({
        circles: Object.freeze([
          Object.freeze({ cx: "6", cy: "5", fill: "#91D2FA", r: "2" }),
          Object.freeze({ cx: "2", cy: "2", fill: "#91D2FA", r: "2" }),
        ]),
        id: "grp5",
        transform: "translate(14 50)",
      }),
      Object.freeze({
        circles: Object.freeze([
          Object.freeze({ cx: "6", cy: "5", fill: "#F48EA7", r: "2" }),
          Object.freeze({ cx: "2", cy: "2", fill: "#F48EA7", r: "2" }),
        ]),
        id: "grp4",
        transform: "translate(35 50)",
      }),
      Object.freeze({
        circles: Object.freeze([
          Object.freeze({ cx: "2.5", cy: "3", fill: "#9FC7FA", r: "2" }),
          Object.freeze({ cx: "7.5", cy: "2", fill: "#9FC7FA", r: "2" }),
        ]),
        id: "grp1",
        transform: "translate(24)",
      }),
    ]),
    groupId: "Group",
    groupTransform: "translate(467 392)",
    id: "heart-svg",
    path: "M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z",
    viewBox: "467 392 58 57",
  }),
  microphone: Object.freeze({
    path: "M160 352c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96S64 42.98 64 96v160c0 53.02 42.98 96 96 96zM96 96c0-35.29 28.71-64 64-64s64 28.71 64 64v160c0 35.29-28.71 64-64 64s-64-28.71-64-64V96zm216 96h-16c-4.42 0-8 3.58-8 8v56c0 73.46-62.2 132.68-136.73 127.71C83.3 379.18 32 319.61 32 251.49V200c0-4.42-3.58-8-8-8H8c-4.42 0-8 3.58-8 8v50.34c0 83.39 61.65 156.12 144 164.43V480H72c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h176c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8h-72v-65.01C256.71 406.9 320 338.8 320 256v-56c0-4.42-3.58-8-8-8z",
    viewBox: "0 0 320 512",
  }),
});

function getLegacyShortVideoSubscribePresentation(isSubscribed) {
  return isSubscribed
    ? { color: "primary", glyph: "check", variant: "contained" }
    : { color: "secondary", glyph: "plus", variant: "outlined" };
}

function getLegacyTopicChannelIds({ video, videos }) {
  if (!video) {
    return [];
  }

  const peerChannelIds = [];

  videos.forEach((item) => {
    if (
      item.topicId === video.topicId &&
      item.channelId &&
      item.channelId !== video.channelId &&
      !peerChannelIds.includes(item.channelId)
    ) {
      peerChannelIds.push(item.channelId);
    }
  });

  return video.channelId
    ? [video.channelId, ...peerChannelIds.slice(0, 4)]
    : peerChannelIds.slice(0, 4);
}

function getLegacyRecommendedVideoIds({ video, videos }) {
  if (!video) {
    return [];
  }

  return videos
    .filter((item) => item.topicId !== video.topicId)
    .slice(0, 12)
    .map((item) => item.id);
}

function normalizeLegacyShortVideoSeconds(value) {
  const numericValue =
    typeof value === "number"
      ? value
      : typeof value === "string" && value.trim() !== ""
      ? Number(value)
      : Number.NaN;

  if (!Number.isFinite(numericValue)) {
    return undefined;
  }

  return numericValue >= LEGACY_SHORT_VIDEO_MILLISECONDS_THRESHOLD
    ? numericValue / 1000
    : numericValue;
}

function getLegacyShortVideoBoundaryValue(segment, keys, fallback) {
  if (!segment) {
    return fallback;
  }

  for (const key of keys) {
    const value = normalizeLegacyShortVideoSeconds(segment[key]);

    if (typeof value === "number") {
      return value;
    }
  }

  return fallback;
}

function getLegacyShortVideoVideoBounds(content) {
  if (!Array.isArray(content) || content.length === 0) {
    return {
      end: LEGACY_SHORT_VIDEO_FALLBACK_SECONDS,
      start: 0,
    };
  }

  const firstSegment = content[0];
  const lastSegment = content[content.length - 1];
  const start = getLegacyShortVideoBoundaryValue(
    firstSegment,
    ["start", "startTime", "start_time", "startAt", "start_at"],
    0
  );
  const end = getLegacyShortVideoBoundaryValue(
    lastSegment,
    ["end", "endTime", "end_time", "endAt", "end_at"],
    start + LEGACY_SHORT_VIDEO_FALLBACK_SECONDS
  );

  return {
    end: end > start ? end : start + LEGACY_SHORT_VIDEO_FALLBACK_SECONDS,
    start,
  };
}
function getLegacyShortVideoSegmentIndex({ content, defaultIndex, playedSeconds }) {
  let nextIndex = defaultIndex;

  content.forEach((item, index) => {
    if (item.start <= playedSeconds && playedSeconds <= item.end) {
      nextIndex = index;
    }
  });

  return nextIndex;
}

function getLegacyShortVideoPlaybackTransition({
  content,
  end,
  loopNumberLooped,
  loopSlide,
  mainSegmentEndGraceSeconds = 0,
  playedSeconds,
  slideIndex,
  start,
}) {
  const activeSegment = content[slideIndex];

  if (!activeSegment) {
    return { action: "none", loopNumberLooped, slideIndex };
  }

  if (loopSlide) {
    if (playedSeconds > activeSegment.end) {
      return {
        action: "seek-active-slide",
        loopNumberLooped,
        seekTo: activeSegment.start,
        slideIndex,
      };
    }

    return { action: "none", loopNumberLooped, slideIndex };
  }

  if (activeSegment.main && loopNumberLooped > 1) {
    if (playedSeconds > activeSegment.end + mainSegmentEndGraceSeconds) {
      return {
        action: "seek-active-slide",
        loopNumberLooped: loopNumberLooped - 1,
        seekTo: activeSegment.start,
        slideIndex,
      };
    }

    return { action: "none", loopNumberLooped, slideIndex };
  }

  if (playedSeconds >= end) {
    return {
      action: "seek-video-start",
      loopNumberLooped: LEGACY_MAIN_SENTENCE_PASS_COUNT,
      seekTo: start,
      slideIndex: 0,
    };
  }

  const nextSlideIndex = getLegacyShortVideoSegmentIndex({
    content,
    defaultIndex: slideIndex,
    playedSeconds,
  });

  return nextSlideIndex === slideIndex
    ? { action: "none", loopNumberLooped, slideIndex }
    : { action: "select-slide", loopNumberLooped, slideIndex: nextSlideIndex };
}

function getLegacyShortVideoNavigationTransition({ loopNumberLooped, slideIndex }) {
  return { action: "seek-slide", loopNumberLooped, slideIndex };
}

const legacyShortVideoParityContract = Object.freeze({
  LEGACY_MAIN_SENTENCE_PASS_COUNT,
  LEGACY_SHORT_VIDEO_FALLBACK_SECONDS,
  LEGACY_SHORT_VIDEO_MAIN_REPEAT_END_GRACE_SECONDS,
  getLegacyRecommendedVideoIds,
  getLegacyShortVideoNavigationTransition,
  getLegacyShortVideoPlaybackTransition,
  getLegacyShortVideoVideoBounds,
  getLegacyShortVideoSubscribePresentation,
  getLegacyTopicChannelIds,
  legacyShortVideoColors,
  legacyShortVideoIcons,
});

export {
  LEGACY_MAIN_SENTENCE_PASS_COUNT,
  LEGACY_SHORT_VIDEO_FALLBACK_SECONDS,
  LEGACY_SHORT_VIDEO_MAIN_REPEAT_END_GRACE_SECONDS,
  getLegacyRecommendedVideoIds,
  getLegacyShortVideoNavigationTransition,
  getLegacyShortVideoPlaybackTransition,
  getLegacyShortVideoVideoBounds,
  getLegacyShortVideoSubscribePresentation,
  getLegacyTopicChannelIds,
  legacyShortVideoColors,
  legacyShortVideoIcons,
};

export default legacyShortVideoParityContract;
